import React, { useEffect } from "react";
import { useState } from "react";
import "../../css_files/Master/AddPartsMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import getCookie from "../../api";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";
import Select from "react-select";

function AddPartsMaster({
  setshowaddform,
  reload,
  setReload,
  triggerupdate,
  partsupdatedata,
}) {
  const [unitData, setUnitData] = useState([]);
  const [gstData, setGstData] = useState([]);
  const [hsnData, setHsnData] = useState([]);
  const [packingData, setPackingData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [subcategoryData, setsubcategoryData] = useState([]);
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState("");

  const [partsData, setPartsData] = useState({
    PartNumber: triggerupdate ? partsupdatedata?.partNumber : "",
    Name: triggerupdate ? partsupdatedata?.name : "",
    Description: triggerupdate ? partsupdatedata?.description : "",
    SellingPrice: triggerupdate ? partsupdatedata?.sellingPrice : "",
    Weight: triggerupdate ? partsupdatedata?.weight : "",
    Length: triggerupdate ? partsupdatedata?.dimensions.split("x")[0] : "",
    Breadth: triggerupdate ? partsupdatedata?.dimensions.split("x")[1] : "",
    Height: triggerupdate ? partsupdatedata?.dimensions.split("x")[2] : "",
    MaterialOfConstruction: triggerupdate
      ? partsupdatedata?.materialOfConstruction
      : "",
    UnitId: triggerupdate ? partsupdatedata?.unitId : "",
    GSTId: triggerupdate ? partsupdatedata?.gstId : null,
    HSNDetailsId: triggerupdate ? partsupdatedata?.hsnDetailsId : null,
    PackingId: triggerupdate ? partsupdatedata?.packingId : null,
    CategoryId: triggerupdate ? partsupdatedata?.categoryId : null,
    SubCategoryId: triggerupdate ? partsupdatedata?.subcategoryId : null,
    IBR: triggerupdate ? partsupdatedata?.ibr : false,
  });

  const [rotatereload, setrotatereload] = useState({
    reloadUnitDropdown: false,
    reloadGstDropdown: false,
    reloadHSNDropdown: false,
    reloadPackingDropdown: false,
    reloadCategoryDropdown: false,
    rotateUnitdropdownicon: false,
    rotateGstdropdownicon: false,
    rotateHsndropdownicon: false,
    rotatePackingdropdownicon: false,
    rotateCategorydropdownicon: false,
    rotatesubcategorydropdownicon: false,
  });

  useEffect(() => {
    setrotatereload({ ...rotatereload, rotateUnitdropdownicon: true });
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Unit/GetUnitDropdown`)
      .then((res) => {
        setUnitData(res.data);
      })
      .catch(console.log)
      .finally(() => {
        setrotatereload({ ...rotatereload, rotateUnitdropdownicon: false });
      });
  }, [rotatereload.reloadUnitDropdown]);

  useEffect(() => {
    setrotatereload({ ...rotatereload, rotateGstdropdownicon: true });
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/GST/GetGSTDropdown`)
      .then((res) => {
        setGstData(res.data);
      })
      .catch(console.log)
      .finally(() => {
        setrotatereload({ ...rotatereload, rotateGstdropdownicon: false });
      });
  }, [rotatereload.reloadGstDropdown]);

  useEffect(() => {
    setrotatereload({ ...rotatereload, rotateHsndropdownicon: true });
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/HSN/GetHSNDropdown`)
      .then((res) => {
        setHsnData(res.data);
      })
      .catch(console.log)
      .finally(() => {
        setrotatereload({ ...rotatereload, rotateHsndropdownicon: false });
      });
  }, [rotatereload.reloadHSNDropdown]);

  useEffect(() => {
    setrotatereload({ ...rotatereload, rotatePackingdropdownicon: true });
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Packing/GetPackingDropdown`)
      .then((res) => {
        setPackingData(res.data);
      })
      .catch(console.log)
      .finally(() => {
        setrotatereload({ ...rotatereload, rotatePackingdropdownicon: false });
      });
  }, [rotatereload.reloadPackingDropdown]);

  useEffect(() => {
    setrotatereload({ ...rotatereload, rotateCategorydropdownicon: true });

    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Category/GetCategoryDropdown`
      )
      .then((res) => {
        setCategoryData(res.data);
      })
      .catch(console.log)
      .finally(() => {
        setrotatereload({ ...rotatereload, rotateCategorydropdownicon: false });
      });
  }, [rotatereload.reloadCategoryDropdown]);

  function fetchsubcategories(categoryId) {
    setrotatereload({ ...rotatereload, rotatesubcategorydropdownicon: true });
    const URL = `${process.env.REACT_APP_API_URL}/api/v1/SubCategory/GetSubCategoryByCategoryId/${categoryId}`;
    axiosInstance
      .get(URL)
      .then((response) => {
        setsubcategoryData(response.data);
        setrotatereload({
          ...rotatereload,
          rotatesubcategorydropdownicon: false,
        });
      })
      .catch((error) => {
        console.log(error);
        setrotatereload({
          ...rotatereload,
          rotatesubcategorydropdownicon: false,
        });
      });
  }

  useEffect(() => {
    fetchsubcategories(partsData.CategoryId);
  }, [partsData.CategoryId]);

  function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    if (triggerupdate) {
      const URL = `${process.env.REACT_APP_API_URL}/api/v1/Parts/UpdatePart`;
      axiosInstance
        .post(URL, {
          ...partsData,
          id: partsupdatedata.id,
          Weight: partsData.Weight || "0",
          Dimensions: `${partsData.Length || "0"}x${partsData.Breadth || "0"}x${
            partsData.Height || "0"
          }`,
        })
        .then((res) => {
          toast.success(res.data.message, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          console.error(error);
          if (error.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Update Record", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          setloading(false);
        });
    } else {
      const URL = `${process.env.REACT_APP_API_URL}/api/v1/Parts`;
      axiosInstance
        .post(URL, {
          ...partsData,
          Weight: partsData.Weight || "0",
          Dimensions: `${partsData.Length || "0"}x${partsData.Breadth || "0"}x${
            partsData.Height || "0"
          }`,
        })
        .then((response) => {
          toast.success("Record Added Successfully", {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          if (error.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Add Record", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          setloading(false);
        });
    }
  }
  return (
    <form className="add-parts-master" onSubmit={handleSubmit}>
      <blockquote>
        <label>
          Part Number{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="text"
          placeholder="Enter Part Number"
          value={partsData.PartNumber}
          onChange={(e) =>
            setPartsData({ ...partsData, PartNumber: e.target.value })
          }
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 50);
          }}
          required
        />
      </blockquote>
      <blockquote>
        <label>
          Part Name{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="text"
          value={partsData.Name}
          placeholder="Enter Part Name"
          onChange={(e) => setPartsData({ ...partsData, Name: e.target.value })}
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 200);
            /*axiosInstance
              .get(
                `${process.env.REACT_APP_API_URL}/api/v1/Parts/GetPartsByIdAndName?name=${e.target.value}&page=1`
              )
              .then(() => setMessage("Part Already Exists With this Name"))
              .catch(() => setMessage(""));*/
          }}
          required
        />
        <span style={{ color: "red" }}>{message}</span>
      </blockquote>
      <blockquote>
        <label>Description</label>
        <textarea
          rows={5}
          placeholder="Enter Part Description (Upto 400 Characters)"
          value={partsData.Description}
          onChange={(e) =>
            setPartsData({ ...partsData, Description: e.target.value })
          }
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 400);
          }}
        ></textarea>
      </blockquote>

      <blockquote>
        <label>Category Name </label>
        <aside>
          <Select
            isSearchable
            options={categoryData}
            onChange={(values) => {
              if (values) {
                setPartsData({
                  ...partsData,
                  CategoryId: values?.value,
                });
              }
            }}
            menuPlacement="top"
            value={categoryData?.find((x) => x?.value == partsData.CategoryId)}
            isClearable
            placeholder="Select Category"
            styles={{
              container: (base) => ({
                ...base,
                width: "100%",
              }),
              placeholder: (base) => ({
                ...base,
                color: "black",
              }),
              control: (base, state) => ({
                ...base,
                borderColor: "black",
                "&:hover": {
                  borderColor: "black",
                },
                boxShadow: "none",
              }),
              singleValue: (base) => ({
                ...base,
                color: "black",
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: "black",
                "&:hover": {
                  color: "black",
                },
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: "black",
              }),
              noOptionsMessage: (base) => ({
                ...base,
                color: "black",
              }),
            }}
          />
          <i
            class={`fa-solid fa-rotate-right ${
              rotatereload.rotateCategorydropdownicon && "fa-spin"
            }`}
            title="refresh dropdown"
            onClick={() =>
              setrotatereload({
                ...rotatereload,
                reloadCategoryDropdown: !rotatereload.reloadCategoryDropdown,
              })
            }
          ></i>
        </aside>
      </blockquote>
      <blockquote>
        <label>Subcategory Name </label>
        <aside>
          <select
            onChange={(e) =>
              setPartsData({
                ...partsData,
                SubCategoryId: e.target.value,
              })
            }
          >
            <option value="">Select Sub-Category</option>
            {subcategoryData.map((subcategory, index) => (
              <option
                key={index}
                value={subcategory.id}
                selected={partsData.SubCategoryId === subcategory.id}
              >
                {subcategory.name}
              </option>
            ))}
          </select>
          <i
            class={`fa-solid fa-rotate-right ${
              rotatereload.rotatesubcategorydropdownicon && "fa-spin"
            }`}
            title="refresh dropdown"
            onClick={() => {
              fetchsubcategories(partsData.CategoryId);
            }}
          ></i>
        </aside>
      </blockquote>
      <blockquote>
        <label>
          Units{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <aside>
          <Select
            isSearchable
            options={unitData}
            onChange={(values) => {
              if (values) {
                setPartsData({
                  ...partsData,
                  UnitId: values?.value,
                });
              }
            }}
            value={unitData?.find((x) => x?.value == partsData.UnitId)}
            isClearable
            required
            placeholder="Select Unit"
            menuPlacement="top"
            styles={{
              container: (base) => ({
                ...base,
                width: "100%",
              }),
              placeholder: (base) => ({
                ...base,
                color: "black",
              }),
              control: (base, state) => ({
                ...base,
                borderColor: "black",
                "&:hover": {
                  borderColor: "black",
                },
                boxShadow: "none",
              }),
              singleValue: (base) => ({
                ...base,
                color: "black",
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: "black",
                "&:hover": {
                  color: "black",
                },
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: "black",
              }),
              noOptionsMessage: (base) => ({
                ...base,
                color: "black",
              }),
            }}
          />
          <i
            class={`fa-solid fa-rotate-right ${
              rotatereload.rotateUnitdropdownicon && "fa-spin"
            }`}
            title="refresh dropdown"
            onClick={() =>
              setrotatereload({
                ...rotatereload,
                reloadUnitDropdown: !rotatereload.reloadUnitDropdown,
              })
            }
          ></i>
        </aside>
      </blockquote>
      <blockquote>
        <label>GST Rate </label>
        <aside>
          <Select
            isSearchable
            options={gstData}
            onChange={(values) => {
              if (values) {
                setPartsData({
                  ...partsData,
                  GSTId: values?.value,
                });
              }
            }}
            value={gstData?.find((x) => x?.value == partsData.GSTId)}
            isClearable
            styles={{
              container: (base) => ({
                ...base,
                width: "100%",
              }),
              placeholder: (base) => ({
                ...base,
                color: "black",
              }),
              control: (base, state) => ({
                ...base,
                borderColor: "black",
                "&:hover": {
                  borderColor: "black",
                },
                boxShadow: "none",
              }),
              singleValue: (base) => ({
                ...base,
                color: "black",
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: "black",
                "&:hover": {
                  color: "black",
                },
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: "black",
              }),
              noOptionsMessage: (base) => ({
                ...base,
                color: "black",
              }),
            }}
            placeholder="Select GST"
            menuPlacement="top"
          />
          <i
            class={`fa-solid fa-rotate-right ${
              rotatereload.rotateGstdropdownicon && "fa-spin"
            }`}
            title="refresh dropdown"
            onClick={() =>
              setrotatereload({
                ...rotatereload,
                reloadGstDropdown: !rotatereload.reloadGstDropdown,
              })
            }
          ></i>
        </aside>
      </blockquote>
      <blockquote>
        <label>HSN Code </label>
        <aside>
          <Select
            isSearchable
            options={hsnData}
            onChange={(values) => {
              if (values) {
                setPartsData({
                  ...partsData,
                  HSNDetailsId: values?.value,
                });
              }
            }}
            menuPlacement="top"
            value={hsnData?.find((x) => x?.value == partsData.HSNDetailsId)}
            styles={{
              container: (base) => ({
                ...base,
                width: "100%",
              }),
              placeholder: (base) => ({
                ...base,
                color: "black",
              }),
              control: (base, state) => ({
                ...base,
                borderColor: "black",
                "&:hover": {
                  borderColor: "black",
                },
                boxShadow: "none",
              }),
              singleValue: (base) => ({
                ...base,
                color: "black",
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: "black",
                "&:hover": {
                  color: "black",
                },
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: "black",
              }),
              noOptionsMessage: (base) => ({
                ...base,
                color: "black",
              }),
            }}
            placeholder="Select HSN"
            isClearable
          />
          <i
            class={`fa-solid fa-rotate-right ${
              rotatereload.rotateHsndropdownicon && "fa-spin"
            }`}
            title="refresh dropdown"
            onClick={() =>
              setrotatereload({
                ...rotatereload,
                reloadHSNDropdown: !rotatereload.reloadHSNDropdown,
              })
            }
          ></i>
        </aside>
      </blockquote>
      {/*<blockquote>
        <label>
          Types of Supply{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <aside>
          <mark>
            <p>Goods</p>
            <input
              type="radio"
              name="supply"
              onChange={(e) =>
                setPartsData({ ...partsData, SupplyType: e.target.value })
              }
              value="Goods"
              checked={partsData.SupplyType === "Goods"}
              required
            />
          </mark>
          <mark>
            <p>Service</p>
            <input
              type="radio"
              name="supply"
              onChange={(e) =>
                setPartsData({ ...partsData, SupplyType: e.target.value })
              }
              value="Service"
              checked={partsData.SupplyType === "Service"}
              required
            />
          </mark>
        </aside>
      </blockquote>*/}
      <blockquote>
        <label>
          Selling Price{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="number"
          placeholder="Enter Selling Price"
          onChange={(e) =>
            setPartsData({ ...partsData, SellingPrice: e.target.value })
          }
          value={partsData.SellingPrice}
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 10);
          }}
          required
        />
      </blockquote>
      <blockquote>
        <label>Weight</label>
        <input
          type="number"
          placeholder="Enter Weight"
          onChange={(e) =>
            setPartsData({ ...partsData, Weight: e.target.value })
          }
          value={partsData.Weight}
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 5);
          }}
        />
      </blockquote>
      <blockquote>
        <label>Dimensions (Centimetre)</label>
        <aside id="dimensions-add-parts-master-form">
          <mark>
            <p>Length</p>
            <input
              type="number"
              placeholder="Enter Length"
              onChange={(e) =>
                setPartsData({ ...partsData, Length: e.target.value })
              }
              value={partsData.Length}
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 5);
              }}
            />
          </mark>
          <mark>
            <p>Breadth</p>
            <input
              type="number"
              placeholder="Enter Breadth"
              onChange={(e) =>
                setPartsData({ ...partsData, Breadth: e.target.value })
              }
              value={partsData.Breadth}
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 5);
              }}
            />
          </mark>
          <mark>
            <p>Height</p>
            <input
              type="number"
              placeholder="Enter Height"
              onChange={(e) =>
                setPartsData({ ...partsData, Height: e.target.value })
              }
              value={partsData.Height}
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 5);
              }}
            />
          </mark>
        </aside>
      </blockquote>
      <blockquote>
        <label>Packing </label>
        <aside>
          <Select
            isSearchable
            options={packingData}
            onChange={(values) => {
              if (values) {
                setPartsData({
                  ...partsData,
                  PackingId: values?.value,
                });
              }
            }}
            value={packingData?.find((x) => x?.value == partsData.PackingId)}
            isClearable
            styles={{
              container: (base) => ({
                ...base,
                width: "100%",
              }),
              placeholder: (base) => ({
                ...base,
                color: "black",
              }),
              control: (base, state) => ({
                ...base,
                borderColor: "black",
                "&:hover": {
                  borderColor: "black",
                },
                boxShadow: "none",
              }),
              singleValue: (base) => ({
                ...base,
                color: "black",
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: "black",
                "&:hover": {
                  color: "black",
                },
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: "black",
              }),
              noOptionsMessage: (base) => ({
                ...base,
                color: "black",
              }),
            }}
            placeholder="Select Packing"
            menuPlacement="top"
          />
          <i
            class={`fa-solid fa-rotate-right ${
              rotatereload.rotatePackingdropdownicon && "fa-spin"
            }`}
            title="refresh dropdown"
            onClick={() =>
              setrotatereload({
                ...rotatereload,
                reloadPackingDropdown: !rotatereload.reloadPackingDropdown,
              })
            }
          ></i>
        </aside>
      </blockquote>
      <blockquote>
        <label>Material of Construction (MOC) </label>
        <input
          type="text"
          placeholder="Enter Material of Construction (MOC)"
          onChange={(e) =>
            setPartsData({
              ...partsData,
              MaterialOfConstruction: e.target.value,
            })
          }
          value={partsData.MaterialOfConstruction}
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 100);
          }}
        />
      </blockquote>

      <blockquote style={{ flexDirection: "row", alignItems: "center" }}>
        <input
          type="checkbox"
          checked={partsData.IBR}
          onChange={(e) => {
            if (e.target.checked) {
              setPartsData({ ...partsData, IBR: true });
            } else {
              setPartsData({ ...partsData, IBR: false });
            }
          }}
        />
        <label>IBR Certification</label>
      </blockquote>
      <button type="submit">{triggerupdate ? "Update" : "Add"} </button>
      <CloseForm close={setshowaddform} />
      {loading && <LoadingScreen />}
    </form>
  );
}

export default AddPartsMaster;
